import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {environment} from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class CompanyCommentService {

  constructor(private http: HttpClient) {
  }

  add(value: any) {
    return this.http.post(`${environment.apiUrl}/Comment`, value)
  }

  get(filter: any | null = null) {
    let params = new HttpParams();
    for (const key in filter) {
      if (filter[key])
        params = params.append(key, filter[key]);
    }

    return this.http.get(`${environment.apiUrl}/Comment`, {params: params})
  }

  getById(commentId: number) {
    return this.http.get(`${environment.apiUrl}/Comment/GetById?Id=${commentId}`);
  }

  approve(commentId: number) {
    return this.http.get(`${environment.apiUrl}/Comment/Approve?id=${commentId}`)
  }

  reject(commentId: number) {
    return this.http.get(`${environment.apiUrl}/Comment/Reject?id=${commentId}`)
  }
}
